import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Moment from 'moment';
import DatePicker from '../../../components/DatePicker/DatePicker';
import NumberInput from 'Components/Form/Input/NumberInput/NumberInput';
import { useMediaQuery } from 'react-responsive';
import { extendMoment } from 'moment-range';

const moment = extendMoment(Moment);

// Date format settings.
moment.locale(drupalSettings.path.currentLanguage);

const defaultProps = {
  buttonText: Drupal.t('Book this room'),
  roomAllowsPets: true,
  allowInfants: true,
  adultsLabel: Drupal.t('Adults 12+ yr'),
  kidsLabel: Drupal.t('Kids 3-11yr'),
  infantsLabel: Drupal.t('Kids 0-2yr'),
  startDatePlaceholderText: Drupal.t('Check in'),
  endDatePlaceholderText: Drupal.t('Check out'),
  maxGuests: drupalSettings.active_site === 'Ruka' ? 8 : 10,
};

const AccommodationSearchForm = (properties) => {
  const props = {
    ...defaultProps,
    ...properties,
  };

  const { startDate, endDate } = props;
  const isTabletOrMobile = useMediaQuery({ query: '(max-width: 1080px)' });

  const [showDropDown, setDropDown] = useState(false);

  const hideButtonClass = props.hideButton
    ? 'accommodation-reservation-form--hidden-button'
    : '';

  function toggleDropdown(event) {
    event.preventDefault();
    setDropDown(!showDropDown);
  }

  return (
    <>
      <div className={`accommodation-reservation-form ${hideButtonClass}`}>
        <form>
          <div className="accommodation-reservation-form__options-wrapper accomodation-search-form-compact">
            <div className="accommodation-reservation-form__datepicker">
              <DatePicker
                startDate={startDate}
                endDate={endDate}
                startDateId={'ruka_start_date'}
                endDateId={'ruka_end_date'}
                setStartDate={props.setStartDate}
                setEndDate={props.setEndDate}
              />
            </div>
            {!isTabletOrMobile ? (
              <div className="form-item__dropdown">
                <button
                  className="accomodation-search-form-compact__dropdown form-item__select"
                  onClick={toggleDropdown}
                >
                  {Drupal.t('Guests')}
                </button>
                {showDropDown ? (
                  <div className="accomodation-search-form-compact__dropdown-container">
                    <NumberInput
                      id="adults"
                      class="number-input--adults"
                      min={1}
                      max={props.maxGuests - props.kids}
                      label={props.adultsLabel}
                      value={props.adults}
                      setter={props.setAdults}
                      areaLabelIncrease="Increase number of Adults"
                      areaLabelDecrease="Decrease number of Adults"
                      disabled={!props.startDate || !props.endDate}
                    />
                    <NumberInput
                      id="children-4-12"
                      class="number-input--children"
                      label={props.kidsLabel}
                      value={props.kids}
                      setter={props.setChildren}
                      max={props.maxGuests - props.adults}
                      disabled={!props.startDate || !props.endDate}
                    />
                    {props.allowInfants ? (
                      <NumberInput
                        id="children-0-3"
                        class="number-input--children"
                        label={props.infantsLabel}
                        value={props.infants}
                        setter={props.setInfants}
                        disabled={!props.startDate || !props.endDate}
                      />
                    ) : null}

                    <div className="accommodation-reservation-form__filters-wrapper">
                      {props.roomAllowsPets ? (
                        <div className="accommodation-reservation-form__pets">
                          <label className="form-item__label form-item__label--checkbox">
                            <input
                              name="pets"
                              id="pets"
                              type="checkbox"
                              className="visually-hidden"
                              checked={props.pets}
                              onChange={(e) => props.setPets(e.target.checked)}
                            />
                            <span className="checkmark"></span>
                            {Drupal.t('Travelling with a pet (+0€)')}
                          </label>
                        </div>
                      ) : null}
                    </div>
                  </div>
                ) : null}
              </div>
            ) : null}
            <div>
              <button
                onClick={(e) => props.onSubmit(e)}
                className="button button--large-full-width"
              >
                {props.buttonText}
              </button>
            </div>
          </div>
        </form>
      </div>
    </>
  );
};

AccommodationSearchForm.propTypes = {
  startDate: PropTypes.object,
  setStartDate: PropTypes.func,
  endDate: PropTypes.object,
  setEndDate: PropTypes.func,
  adults: PropTypes.number,
  setAdults: PropTypes.func,
  kids: PropTypes.number,
  setChildren: PropTypes.func,
  infants: PropTypes.number,
  setInfants: PropTypes.func,
  maxGuests: PropTypes.func,
  pets: PropTypes.bool,
  setPets: PropTypes.func,
  hideButton: PropTypes.bool,
  onSubmit: PropTypes.func,
  buttonText: PropTypes.string,
  roomAllowsPets: PropTypes.bool,
  allowInfants: PropTypes.bool,
  adultsLabel: PropTypes.string,
  kidsLabel: PropTypes.string,
  infantsLabel: PropTypes.string,
  startDatePlaceholderText: PropTypes.string,
  endDatePlaceholderText: PropTypes.string,
};

export default AccommodationSearchForm;
